import { Helmet } from 'react-helmet';
import { OG_IMAGE_URL, usePageMeta } from '../../../utils/pageMeta';

interface PageHelmetProps {
  path: string;
  title: string;
  description: string;
  schemas?: object[];
  absoluteUrl?: string;
}

export function PageHelmet({ path, title, description, schemas = [], absoluteUrl }: PageHelmetProps) {
  const meta = usePageMeta(path);
  const resolvedUrl = absoluteUrl ?? meta.ogUrl;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={resolvedUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={resolvedUrl} />
      <meta property="og:image" content={OG_IMAGE_URL} />
      <meta property="og:locale" content="ko_KR" />
      <meta property="og:site_name" content="노후든든" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE_URL} />
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
